import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  id: 1,
  ciclo: 'Ciclo A',
  title: 'El Despertar del Movimiento',
  weeks: 'Semanas 1 a 13 · 3 y 4 años',
  desc: 'El primer contacto con la danza. Control motor, lateralidad, espacio personal y pulso básico.',
  color: 'bg-cream-50 border-cream-200 text-wine-900'
}, {
  id: 2,
  ciclo: 'Ciclo A',
  title: 'El Cuerpo en el Espacio',
  weeks: 'Semanas 14 a 26 · 3 y 4 años',
  desc: 'Nociones espaciales completas. Arriba/abajo, trayectorias, niveles y primera mini-coreografía.',
  color: 'bg-cream-50 border-cream-200 text-wine-900'
}, {
  id: 3,
  ciclo: 'Ciclo A',
  title: 'El Ritmo en el Cuerpo',
  weeks: 'Semanas 27 a 39 · 3 y 4 años',
  desc: 'Pulso, tempo, acento, silencio y frase musical. El cuerpo que escucha la música.',
  color: 'bg-cream-50 border-cream-200 text-wine-900'
}, {
  id: 4,
  ciclo: 'Ciclo A',
  title: 'La Gran Muestra',
  weeks: 'Semanas 40 a 52 · 3 y 4 años',
  desc: 'Cierre del Ciclo A. Coreografía de muestra armada con los ejercicios del año. Protocolo completo de show.',
  color: 'bg-cream-100 border-cream-300 text-wine-900'
}, {
  id: 5,
  ciclo: 'Ciclo B',
  title: 'Conciencia Corporal',
  weeks: 'Semanas 1 a 13 · 5 y 6 años',
  desc: 'Segmentos corporales, aislamiento y movimiento con intención. El cuerpo que piensa antes de moverse.',
  color: 'bg-plum-50 border-plum-200 text-plum-900'
}, {
  id: 6,
  ciclo: 'Ciclo B',
  title: 'Espacialidad Avanzada',
  weeks: 'Semanas 14 a 26 · 5 y 6 años',
  desc: 'Dimensiones del espacio, formaciones grupales y calidades de movimiento.',
  color: 'bg-plum-50 border-plum-200 text-plum-900'
}, {
  id: 7,
  ciclo: 'Ciclo B',
  title: 'Musicalidad y Expresión',
  weeks: 'Semanas 27 a 39 · 5 y 6 años',
  desc: 'Frase musical de 8 tiempos, narrativa corporal y primeras herramientas de presencia escénica.',
  color: 'bg-plum-50 border-plum-200 text-plum-900'
}, {
  id: 8,
  ciclo: 'Ciclo B',
  title: 'La Gran Muestra',
  weeks: 'Semanas 40 a 52 · 5 y 6 años',
  desc: 'Cierre del Ciclo B. Coreografía con intención dramática y protocolo completo de show de nivel medio.',
  color: 'bg-plum-100 border-plum-300 text-plum-900'
}, {
  id: 9,
  ciclo: 'Ciclo C',
  title: 'Pre-Técnica Académica',
  weeks: 'Semanas 1 a 13 · 7 y 8 años',
  desc: 'Postura, eje, posiciones de pies y primeras secuencias de barra. El puente hacia la técnica clásica.',
  color: 'bg-wine-50 border-wine-200 text-wine-900'
}, {
  id: 10,
  ciclo: 'Ciclo C',
  title: 'Técnica y Centro',
  weeks: 'Semanas 14 a 26 · 7 y 8 años',
  desc: 'Plié, relevé, tendu y port de bras. Centro con conciencia técnica y calidad de ejecución.',
  color: 'bg-wine-50 border-wine-200 text-wine-900'
}, {
  id: 11,
  ciclo: 'Ciclo C',
  title: 'Técnica Avanzada y Escena',
  weeks: 'Semanas 27 a 39 · 7 y 8 años',
  desc: 'Giros con spot, soubresaut, diagonal y secuencias completas de barra y centro.',
  color: 'bg-wine-50 border-wine-200 text-wine-900'
}, {
  id: 12,
  ciclo: 'Ciclo C',
  title: 'La Gran Muestra Elite',
  weeks: 'Semanas 40 a 52 · 7 y 8 años',
  desc: 'Cierre del Ciclo C. Coreografía académica con presencia escénica real y protocolo profesional de show.',
  color: 'bg-wine-100 border-wine-300 text-wine-900'
}];
export function TomosSection() {
  return <section className="py-20 bg-white border-t border-cream-100" data-id="element-289">
      <div className="max-w-6xl mx-auto px-4" data-id="element-290">
        <div className="text-center mb-16" data-id="element-291">
          <h2 className="font-serif text-4xl font-bold text-gray-900 mb-4" data-id="element-292">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-wine-700 font-medium" data-id="element-293">
            Ejercicios graficados · Por nivel y edad · Listos para usar mañana
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-294">
          {tomos.map((tomo, idx) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className={`rounded-2xl border p-6 flex flex-col h-full ${tomo.color} shadow-sm hover:shadow-md transition-shadow`} data-id="element-295">
              <div className="flex items-center justify-between mb-4" data-id="element-296">
                <span className="font-bold text-lg" data-id="element-297">TOMO {tomo.id}</span>
                <span className="text-xs font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-white/60" data-id="element-298">
                  {tomo.ciclo}
                </span>
              </div>
              <h3 className="font-serif text-xl font-bold mb-2 leading-tight" data-id="element-299">
                {tomo.title}
              </h3>
              <p className="text-sm font-semibold opacity-80 mb-4" data-id="element-300">
                {tomo.weeks}
              </p>
              <p className="text-sm opacity-90 mt-auto leading-relaxed" data-id="element-301">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-wine-900 font-medium bg-cream-50 p-6 rounded-2xl shadow-sm border border-cream-200" data-id="element-302">
          <span className="flex items-center gap-2" data-id="element-303">
            <span className="text-xl" data-id="element-304">✏️</span> Ejercicios graficados en cada
            tomo
          </span>
          <span className="flex items-center gap-2" data-id="element-305">
            <span className="text-xl" data-id="element-306">⚡</span> Sistema "Abrí y Dictás"
          </span>
          <span className="flex items-center gap-2" data-id="element-307">
            <span className="text-xl" data-id="element-308">📋</span> Fichas listas para imprimir
          </span>
          <span className="flex items-center gap-2" data-id="element-309">
            <span className="text-xl" data-id="element-310">🇦🇷</span> Contenido 100% adaptado a
            Argentina
          </span>
        </div>
      </div>
    </section>;
}